import { useQuery } from "@apollo/react-hooks";
import React, { useCallback, useReducer } from "react";
import { get } from "lodash";
import styled from "styled-components";

import { GET_AMAZON_IDEA_TIMELINES } from "../../../graphql/queries/amazon-idea";
import { handleError, reducerFn } from "../../../helper";
import SkeletonPagePolaris from "../../shared/SkeletonPagePolaris";
import { Heading, Stack } from "@shopify/polaris";
import { CustomTimeline } from "../../shared/CustomTimeline";
import PaginationPolaris from "../../shared/PaginationPolaris";

export default function AmazonIdeaTimeline({ node }) {
    const [filter, setFilter] = useReducer(reducerFn, {
        limit: 20,

        offset: 0,

        amazonIdeaID: node?.id,
    });

    const { data, loading, error } = useQuery(GET_AMAZON_IDEA_TIMELINES, {
        variables: {
            filter,
        },

        skip: !node || !node.id,

        fetchPolicy: "no-cache",
    });

    const onChange = useCallback((offset, limit) => {
        setFilter((prev) => ({ ...prev, offset, limit }));
    }, []);

    const total = getTotal(data);

    const options = genOptions(data);

    const aggs = genAgg(filter, total);

    return (
        <Wrapper>
            {loading ? (
                <SkeletonPagePolaris sizeSmall />
            ) : error ? (
                <div>Error: {handleError(error?.toString())}</div>
            ) : options?.length > 0 ? (
                <Stack vertical>
                    <Heading element="h4" children="History" />

                    <CustomTimeline data={options} />

                    <div className="pagination">
                        <PaginationPolaris
                            aggregation={{ ...aggs, onChange }}
                        />
                    </div>
                </Stack>
            ) : null}
        </Wrapper>
    );
}

function getTotal(data) {
    return get(data, "getAmazonIdeaTimelines.total") || 0;
}

function genOptions(data) {
    const nodes = get(data, "getAmazonIdeaTimelines.nodes") || [];

    const res = [];

    for (let node of nodes) {
        res.push({
            id: node.id,
            createdAt: node.createdAt,
            title: node.content,
        });
    }

    return res;
}

function genAgg(filter, total) {
    const { limit, offset } = filter || {};

    const totalPage = Math.ceil(total / limit);

    const page = offset / limit + 1;

    return { page, totalPage, offset, limit };
}

const Wrapper = styled.div`
    border-top: var(
        --p-thin-border-subdued,
        0.1rem solid var(--p-border-subdued, #dfe3e8)
    );
    padding-top: 1rem;
`;
